module.exports = __webpack_public_path__ + "static/media/product3.b0ba61c1.webp";